import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';
import TextNumber from 'components/text/TextNumber';




const PrincipalBondResultList = ({ data }) => {

    const [showPayments, setShowPayments] = useState(false); 
    const [showAllCapitals, setShowAllCapitals] = useState(false); 
    const [showOnlyNoIndex, setShowOnlyNoIndex] = useState(false); 

    const [totalSum, setTotalSum] = useState({
        totalPaymentAndCostAmount : 0
    }); 


  if (!data || Object.keys(data).length == 0){
    return (
      <div/>
    );
  }  




  return (
    <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />            
          </colgroup>
          <thead>
          <tr>
            <th colSpan="10" className="text-left">
              <span className="calc-setting-table-header">Greiðsluflæði í skuldabréfi.&nbsp;&nbsp;&nbsp;&nbsp;</span>
              {/* <input id="checkPrinciaplsid1" type="checkbox" checked={showPayments} onChange={() => setShowPayments(!showPayments)}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid1" >Sýna greiðslur</label> &nbsp; &nbsp; */}
              <input id="checkPrinciaplsid2" type="checkbox" checked={showAllCapitals} onChange={() => setShowAllCapitals(!showAllCapitals)}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid2" >Sýna framtíðar höfuðstóla</label>&nbsp;&nbsp;&nbsp;
              <input id="checkPrinciaplsid3" type="checkbox" checked={showOnlyNoIndex} onChange={() => setShowOnlyNoIndex(!showOnlyNoIndex)}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid3" >Sýna sem óverðtryggt</label>
            </th>
          </tr>
          <tr>
            <th className="text-left">G.nr.</th>
            <th className="text-left">Gjalddagi</th>
            <th className="text-right">Höf. í upph.</th>
            <th className="text-right">Afborgun</th>
            <th className="text-right">Vextir</th>
            <th className="text-right">Vaxta %</th>
            <th className="text-right">Heildargr.</th>
            <th className="text-right">Kostn.</th>
            <th className="text-right">Heildargr.m.kostn.</th>                        
            <th className="text-right">Staða eftir gr.</th>

            <th className="text-right">Verðb afb.</th>
            <th className="text-right">Verðb höfuðs.</th>
            <th className="text-right">Verðb vexta.</th>


          </tr>
          </thead>
          <tbody>
          {data.map((item,i) => {
            if (!showAllCapitals && item.isFuturePayment) {
              return null;
            }        

            let cName = "";
            if (item.paymentNumber % 2 === 1){
              cName = 'calc-setting-table-odd';
            }
            cName = cName + (item.isFuturePayment ? ' highlight-principal-future' : '');
            // if ((item.paymentNumber === 35) || (item.paymentNumber === 68) || (item.paymentNumber === 150)){
            //   cName = ' highlight-principal-mine';
            // }

            
            
            //  console.log("item", item);
        
            return([
                <tr key={i + "inner"} className={cName}>
                  <td className="text-left"><TextNumber value={item.paymentNumber}/></td>                  
                  <td className="text-left"><TextDate value={item.dueDate}/></td>
                   

    
                  <td className="text-right"><b><TextAmount value={showOnlyNoIndex ? item.capitalAmount : item.capitalTotalAmount}/></b></td> 
                  <td className="text-right"><b><TextAmount value={showOnlyNoIndex ? item.amount : item.totalAmount}/></b></td>
                  <td className="text-right"><b><TextAmount value={showOnlyNoIndex ? item.interestAmount : item.interestTotalAmount}/></b></td>
                  {/* <td className="text-right"><TextAmount data={item.interestAmount}/></td> */}
                  <td className="text-right"><TextPercent value={item.interestRate}/></td>
                  <td className="text-right"><TextAmount value={showOnlyNoIndex ? item.paymentAmount : item.paymentTotalAmount}/></td> 
                  <td className="text-right"><TextAmount value={item.costAmount}/></td>                 
                  <td className="text-right"><b><TextAmount value={ showOnlyNoIndex ? item.paymentAmount + item.costAmount : item.paymentTotalAmount + item.costAmount}/></b></td>                                   
                  <td className="text-right"><TextAmount value={item.capitalAfterPaymentTotalAmount}/></td>                 

                  <td className="text-right"><TextAmount value={item.indexOnAmount}/></td>                 
                  <td className="text-right"><TextAmount value={item.indexOnCapitalAmount}/></td>                 
                  <td className="text-right"><TextAmount value={item.indexOnInterestAmount}/></td>         

                </tr>]
            )
          })}

          {/* <tr>
                <td className="text-left"></td>                  
                <td className="text-left"></td>
                <td className="text-right"></td>
                <td className="text-right"></td>
                <td className="text-right"></td>                
                <td className="text-right"></td>
                <td className="text-right"></td> 
                <td className="text-right"></td>                 
                <td className="text-right">{totalSum.totalPaymentAndCostAmount}</td>       
          </tr> */}

          </tbody>
        </table>
      </div>
    );
};

PrincipalBondResultList.propTypes = {
  data: PropTypes.array,
};

export default PrincipalBondResultList;
